import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	container: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		boxShadow: "none",
		margin: "0px !important"
	},
	box: {
		maxWidth: "415px"
	},
	filterInput: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		"& fieldset": {
			borderColor: "transparent",
			borderRadius: 3
		},
		maxHeight: 70,
		overflowY: "auto",
		width: "100%",
		"&::-webkit-scrollbar": {
			width: "0.3em"
		},
		"&::-webkit-scrollbar-track": {
		},
		"&::-webkit-scrollbar-thumb": {
			border: "none",
			outline: 1,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[100])
		}
	},
	grayIcon: {
		color: colors.gray[400]
	},
	dateContainer: {
		flex: 1,
		"& input": {
			fontSize: "14px",
			height: "19px",
			marginLeft: "4px"
		},
		"& button": {
			width: "40px",
			height: "40px"
		},
		"& div": {
			paddingLeft: "0px",
			marginRight: "0px"
		}
	}
})

export default useStyles
